import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns true when running in a browser environment
 * (window + localStorage + document all defined).
 *
 * Used to guard localStorage / event-dispatcher access from SSR and tests
 * that run without a DOM. Centralised so each caller does not redefine its
 * own (slightly different) helper.
 */
export function isBrowser(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.localStorage !== 'undefined' &&
    typeof document !== 'undefined'
  );
}
